import axios from 'axios'
import router from '../router/index'
import user from './user'
import qs from 'qs'
import { Message } from 'element-ui'

axios.defaults.withCredentials = true
window._isGettingToken = false
window.notifyTime = null

const base = process.env.APIBASE
axios.interceptors.response.use(function (response) {
    if (response.data.result && response.data.code === 0) {
        var expireTime = Date.parse(sessionStorage.getItem('expireTime'))
        var date = new Date(expireTime)
        var datenow = new Date()
        const Minute2 = Number((date - datenow) / 60000)
        if (Minute2 < 5 && !window._isGettingToken) {
            window._isGettingToken = true
            var refresh_token = sessionStorage.getItem('refresh_token')
            if (refresh_token !== undefined) {
                user.refreshToken({ refreshToken: refresh_token }).then(function (result) {
                    if (result.code === 0) {
                        sessionStorage.setItem('token', result.result.access_token)
                        sessionStorage.setItem('refresh_token', result.result.refresh_token)
                        var date = new Date()
                        var tsTime = date.getTime()
                        date.setTime(tsTime + result.result.expire * 60000)
                        sessionStorage.setItem('expireTime', date)
                        window._isGettingToken = false
                    }
                    else {
                        sessionStorage.removeItem('refresh_token')
                    }
                })
            }
        }
        if (parseInt(response.data.code) === 401) {
            if (window.notifyTime == null || (window.notifyTime.valueOf() - new Date().valueOf() > 3000)) {
                window.notifyTime = new Date()
                Message.warning({ showClose: true, message: '身份认证已过期', duration: 3000 })
            }
            router.replace({
                path: '/login'
            })
        }
    }
    return response
},
    function (error) {
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    error.message = '身份认证已过期'
                    router.replace({
                        path: '/login'
                    })
                    break
                default:
                    return Promise.reject(error)
            }
        }
        return Promise.reject(error)
    }
)

axios.interceptors.request.use(
    config => {
        var token = sessionStorage.getItem('token')
        if (token !== undefined) {
            config.headers['authorization'] = 'Bearer ' + token
            config.headers['Pragma'] = 'no-cache'
        }
        return config
    },
    error => {
        console.log(error)
        Promise.reject(error)
    }
)


export const POST = (url, params) => {
    return axios.post(`${base}${url}`, params).then(res => res.data)
}
export const POSTFORM = (url, params) => {
    let config = {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }
    return axios.post(`${base}${url}`, params, config).then(res =>
        res.data
    )
}
export const POSTFMT = (url, params) => {
    return axios.post(`${base}${url}`, qs.stringify(params, {
        arrayFormat: 'indices', allowDots: true
    })).then(res => res.data)
}
export const POSTJSON = (url, params) => {
    return axios.post(`${base}${url}`, JSON.stringify(params), {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8'
        }
    }).then(res => res.data)
}
export const GET = (url, params) => {
    return axios.get(`${base}${url}`, {
        params: params
    }).then(res => res.data)
}

export const GETBlog = (url, params) => {
    return axios.get(`${base}${url}`, {
        params: params, responseType: 'blob'
    }).then(res => res.data)
}
export const GETBlog2 = (url, params) => {
    return axios.get(`${base}${url}`, {
        params: params, responseType: 'blob'
    }).then(res => res)
}
export const PUT = (url, params) => {
    return axios.put(`${base}${url}`, params).then(res => res.data)
}

export const DELETE = (url, params) => {
    return axios.delete(`${base}${url}`, { params: params }).then(res => res.data)
}
export const DELETEBATCH = (url, params) => {
    return axios.delete(`${base}${url}`, { params: params }).then(res => res.data)
}
export const PATCH = (url, params) => {
    return axios.patch(`${base}${url}`, params).then(res => res.data)
}



// WEBPACK FOOTER //
// ./src/apis/index.js